export enum ButtonTypeEnum {
  default = 0,
  outline = 1
}
